import axios from "axios";

// En production Vercel, l’API peut être servie en same-origin sur `/api/*` (see /api/* serverless)
// On évite toute construction du type: `undefined/api/...`
const BACKEND_BASE = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
export const API = BACKEND_BASE ? `${BACKEND_BASE}/api` : "/api";

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export async function submitLead(payload) {
  const { data } = await api.post("/leads", payload);
  return data;
}

export async function fetchBudget() {
  const { data } = await api.get("/budget/progress");
  return data;
}
